module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "col s12 m2 l2"
  }, [_c('ul', {
    staticClass: "collection"
  }, [_c('li', {
    staticClass: "collection-item nav-suite-nupcias"
  }, [_c('a', {
    staticClass: "white-text",
    attrs: {
      "href": "#/acomodacoes/suite-nupcias"
    }
  }, [_vm._v("Suíte de Núpcias")])]), _vm._v(" "), _c('li', {
    staticClass: "collection-item nav-quarto-casal"
  }, [_c('a', {
    staticClass: "white-text",
    attrs: {
      "href": "#/acomodacoes/quarto-casal"
    }
  }, [_vm._v("Quarto Casal")])]), _vm._v(" "), _c('li', {
    staticClass: "collection-item nav-quarto-duplo"
  }, [_c('a', {
    staticClass: "white-text",
    attrs: {
      "href": "#/acomodacoes/quarto-duplo"
    }
  }, [_vm._v("Quarto Duplo")])]), _vm._v(" "), _c('li', {
    staticClass: "collection-item nav-quarto-individual"
  }, [_c('a', {
    staticClass: "white-text",
    attrs: {
      "href": "#/acomodacoes/quarto-individual"
    }
  }, [_vm._v("Quarto Individual")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col s12 m10 l10"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "slider"
  }, [_c('ul', {
    staticClass: "slides"
  }, [_c('li', [_c('img', {
    attrs: {
      "src": require("../../img/galeriaFotos/110.jpg")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "caption left-align"
  }, [_c('h3', [_vm._v("Quarto Casal")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": require("../../img/galeriaFotos/111.jpg")
    }
  })]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": require("../../img/galeriaFotos/090.jpg")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "caption right-align"
  }, [_c('h3', [_vm._v("Toaletes")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s12 m12 l12"
  }, [_c('div', {
    staticClass: "card z-depth-2 hoverable"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('span', {
    staticClass: "card-title"
  }, [_vm._v("Acomodações")]), _vm._v(" "), _c('p', [_vm._v("Nossos apartamentos e suítes são todos de luxo e oferecem\n                                    excelente estrutura e conforto equipados com "), _c('b', [_vm._v("frigobar, ar condicionado,\n                                        ventilador, TV e armário com cabides.")])]), _vm._v(" "), _c('p', [_vm._v("Explore os diferentes tipos de apartamentos!")])])])])])])])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7796d6e2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7796d6e2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/acomodacoes/quarto-casal.vue
// module id = 85
// module chunks = 0